import {Config} from "./config-viewmodel";

export interface MyFavoriteStudiesState {
    inner_loading: boolean
    is_favorite: boolean
    favorite_id: number|null
    config: Config
}

export class WidgetState implements MyFavoriteStudiesState {
    inner_loading: boolean = false
    is_favorite: boolean = false
    favorite_id: number|null = null
    config: Config = {
        labels: {
            buttonTextFavorite: '',
            buttonTextNotFavorite: ''
        },
        study_code: '',
        language: ''
    }
}
